import { gql } from '@apollo/client';
import gqlClient from '../../../../utils/apolloClient';

const insertStationMutation = gql`
  mutation ($object: emergencies_insert_input!) {
    insert_emergencies_one(object: $object) {
      id
    }
  }
`;

export const createStation = async (variables: object) => {
  const res = await gqlClient.mutate<{
    insert_emergencies_one: {
      id: string,
    }
  }>({ mutation: insertStationMutation!, variables });
  return res.data?.insert_emergencies_one.id;
}
